<div
  class="cbl--item cbl--grid"
  [class.nuclear]="game().mode === 'nuclear'"
  [class.equity]="game().mode === 'equity'"
  [class.crazy]="game().mode === 'crazy'"
  [class.normal]="game().mode === 'normal'"
>
  <div class="cbl--grid-1">
    <div class="cbl--item__rounds">
      <span class="cbl--item__rounds-quantity">{{ game().cases.length }}</span>
    </div>
    <p
      class="cbl--item__status"
      [class.dots-animation]="
        game().status === 'open' || game().status === 'running'
      "
    >
      {{ STATUSES[game().status] }}
    </p>
  </div>
  <div class="divider vertical h-full"></div>

  <div class="cbl--grid-2">
    <app-cb-cases-progress
      [@fadeInAnimation]
      [balance]="playerBalance()"
      [battle]="game()"
      [settings]="casesProgressSettings()"
    ></app-cb-cases-progress>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="cbl--grid-3">
    <app-cb-list-mode [game]="game()"></app-cb-list-mode>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="cbl--grid-4">
    <app-cost
      class="cbl--item__cost"
      [gap]="4"
      [color]="
        game().mode === 'nuclear'
          ? 'var(--case-battle-nuclear)'
          : game().mode === 'equity'
          ? 'var(--case-battle-equity)'
          : game().mode === 'crazy'
          ? 'var(--case-battle-crazy)'
          : game().mode === 'normal'
          ? 'var(--case-battle-normal)'
          : 'var(--yellow)'
      "
      [cost]="game().value"
      [balanceType]="playerBalance()"
    ></app-cost>

    @if (game().cover && game().cover > 0) {
    <span class="cbl--item__cover"> -{{ game().cover }}% </span>
    }
  </div>
  <div class="divider vertical h-full"></div>
  <div class="cbl--grid-5">
    @if (game().status === 'finished') {
    <button (click)="handleViewBattle(game())" class="cbl--item__finished">
      <svg-icon
        class="flex items-center justify-center s-24"
        src="assets/images/deprecated/eye-icon.svg"
      />
      View Battle
    </button>
    }

    <!--  -->
    @if (game().status === 'running') {
    <a class="cbl--item__running">
      <svg-icon
        class="flex items-center justify-center s-14"
        src="assets/icons/ui/loading.svg"
        svgClass="loading-animation"
        [svgStyle]="{ width: '14px', height: '14px', fill: 'black' }"
      ></svg-icon>
      <span class="dots-animation">on-going</span>
    </a>
    }
    <!--  -->
    @if (game().status === 'open') {
    <!--  -->
    @if (sessionService.profile()?.steamid === game().host) {
    <a class="cbl--item__bots" (click)="callBotsBattle()">
      <app-game-icon color="black" [game]="'Case Battles'"></app-game-icon>
      call bots
    </a>
    } @else {
    <a class="cbl--item__join" (click)="handleJoinBattle()">
      <app-game-icon color="black" [game]="'Case Battles'"></app-game-icon>
      join battle
    </a>
    }
    <!--  -->
    }
    <!--  -->
    @if (game().status === 'open' || game().status === 'running') {
    <button class="cbl--item__view" (click)="handleViewBattle(game())">
      <svg-icon
        class="flex items-center justify-center s-24"
        src="assets/images/deprecated/eye-icon.svg"
      />
    </button>
    }
  </div>
</div>
